const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const WS_URL = "wss://wbs.mexc.com/ws";

// WS требует Min/Hour формат, REST — обычный
const mapWsInterval = (tf) => ({
  "1m":"Min1","5m":"Min5","15m":"Min15","30m":"Min30","1h":"Min60",
  "4h":"Hour4","8h":"Hour8","1d":"Day1","7d":"Week1","30d":"Month1",
}[tf] || "Min1");

const restInterval = (tf) => ({
  "1m":"1m","5m":"5m","15m":"15m","30m":"30m","1h":"1h","4h":"4h","8h":"8h","1d":"1d","7d":"1w","30d":"1M",
}[tf] || "1m");

const toSec = (x) => (x > 2e10 ? Math.floor(x/1000) : Number(x));
const toLwc = (t, o, h, l, c) => ({
  time: t,
  open: Number.isFinite(+o) ? +o : undefined,
  high: Number.isFinite(+h) ? +h : undefined,
  low:  Number.isFinite(+l) ? +l : undefined,
  close:Number.isFinite(+c) ? +c : undefined,
});

export async function mexcSpotFetchHistory({ symbol, interval, limit = 300 }) {
  const url = `${PROXY}/https://api.mexc.com/api/v3/klines?symbol=${encodeURIComponent(symbol)}&interval=${encodeURIComponent(restInterval(interval))}&limit=${limit}`;
  console.log("[mexcSpot REST] fetch", { symbol, interval, limit, url });
  const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
  if (!r.ok) throw new Error(`MEXC SPOT HTTP ${r.status}`);
  const rows = await r.json();
  // resp: [ openTime, open, high, low, close, volume, closeTime, quoteVol, ... ]
  const out = rows
    .map(a => toLwc(toSec(+a[0]), +a[1], +a[2], +a[3], +a[4]))
    .sort((x,y)=>x.time-y.time)
    .slice(-limit);
  console.log("[mexcSpot REST] done", { symbol, interval, count: out.length });
  return out;
}

export function mexcSpotOpenWS({ symbol, interval, onCandle }) {
  const chan = `spot@public.kline.v3.api.pb@${symbol}@${mapWsInterval(interval)}`;
  console.log("[mexcSpot WS] open", { symbol, interval, chan });
  const ws = new WebSocket(WS_URL);

  const close = () => { try { ws.close(); } catch{} console.log("[mexcSpot WS] closed"); };

  ws.onopen = () => {
    const sub = { method: "SUBSCRIPTION", params: [chan] };
    ws.send(JSON.stringify(sub));
    console.log("[mexcSpot WS] subscribed", sub);
  };

  ws.onmessage = (evt) => {
    try {
      const msg = JSON.parse(evt.data);
      if (!msg?.publicspotkline) return;
      const k = msg.publicspotkline;
      const c = toLwc(toSec(+k.windowstart), +k.openingprice, +k.highestprice, +k.lowestprice, +k.closingprice);
      onCandle?.(c);
    } catch {}
  };

  ws.onerror = (e) => console.warn("[mexcSpot WS] error", e);
  ws.onclose = () => console.log("[mexcSpot WS] onclose");

  return close;
}
